import React from 'react';
import PropTypes from 'prop-types';

import Icon from './icon';

const IgniteFormCheckbox = ({
	action,
	disabled = false,
	id,
	label,
	name = '',
	value,
}) => (
	<div className="form__container">
		<label className="form-checkbox-label">
			{label}
			<input
				type="checkbox"
				name={name}
				id={id}
				disabled={disabled}
				checked={value ? 'checked' : ''}
				onChange={action}
			/>
			<span className="form-checkbox"><Icon icon="check" title="" /></span>
		</label>
	</div>
);

export default IgniteFormCheckbox;

IgniteFormCheckbox.propTypes = {
	action: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	name: PropTypes.string,
	value: PropTypes.bool.isRequired,
};
